import React from "react";
import { DropzoneAreaBase } from "material-ui-dropzone";
import { MasterOfActsAPI } from "../../../../api/api";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import { getActs } from "../../../../redux/reducers/act-reducer";
import {useSelector} from "react-redux";
import { getProfile } from "../../../../redux/reducers/user-profile-reducer";
import { downloadContractorRemovalFile } from "../../../../redux/reducers/contractor-act-reducer";


const useStyles = makeStyles(() => ({
  previewChip: {
    minWidth: 160,
    maxWidth: 210,
  },
  header: {
    fontSize: "1rem",
    fontWeight: 400,
  },
}));

export const DragAndDropActUpload = ({
  content,
  label,
  name,
  value,
  setFieldValue,
  disabled,
  selectedactid
}) => {
  const classes = useStyles();

  const {selectedAct} = useSelector(getActs)
  const { user } = useSelector(getProfile);

  const onAddFile = async (newFiles) => {
    let acceptedFiles = [];
    for (const newFile of newFiles) {
      const response = await MasterOfActsAPI.uploadContractorRemovalFiles(
        newFile.file.name,
        newFile.file.type,
        selectedAct?.creator || user.id,
        newFile.file,
        selectedactid
      );
      if (response.status === 201) {
        acceptedFiles = [...acceptedFiles, {file: {name: newFile.file.name}, id: response.data.id}]
      }
    } 
    setFieldValue(name, [...value, ...acceptedFiles])
  };

  const onDeleteFile = async (file) => {
    const response = await MasterOfActsAPI.deleteContractorRemovalFile(file.id);
    if (
      response.status === 203 ||
      response.status === 204 ||
      response.status === 202
    ) {
      setFieldValue(
        name,
        value.filter((f) => f !== file)
      );
    }
  };

  const onDownloadFile = async (event) => {
    const filename = event.target.outerText;
    const fileId = value.filter((f) => f.file.name === filename)[0].id;
    await downloadContractorRemovalFile(fileId);
  };

  return (
    <>
      <Typography className={classes.header} variant={"h6"}>
        Файлы, подтверждающие исправление
      </Typography>
      <DropzoneAreaBase
        fileObjects={value}
        acceptedFiles={content.acceptedFiles}
        dropzoneText={label}
        onAdd={onAddFile}
        onDelete={onDeleteFile}
        filesLimit={9}
        getFileLimitExceedMessage={(filesLimit) =>
          `Превышено максимально допустимое количество файлов. Разрешено только ${filesLimit} `
        }
        getFileAddedMessage={(fileName) => `Файл ${fileName} успешно добавлен `}
        getFileRemovedMessage={(fileName) => `Файл ${fileName} удален `}
        getDropRejectMessage={(rejectedFile) =>
          `Файл ${rejectedFile.name} был отклонен `
        }
        showPreviews={true}
        showPreviewsInDropzone={false}
        useChipsForPreview
        previewGridProps={{ container: { spacing: 1, direction: "row" } }}
        previewChipProps={{
          classes: {
            root: classes.previewChip,
          },
          onClick: onDownloadFile,
        }}
        previewText="Загруженные файлы"
        dropzoneProps={{ disabled: disabled }}
      />
    </>
  );
};
